module.exports = __webpack_public_path__ + "assets/img/8692d340889a11dbc24de929acb933c4.png";